import { useNavigate } from "react-router-dom";
import { EnrollMFA } from "@/components/mfa/EnrollMFA";
import { useAuth } from "@/contexts/AuthContext";
import { useMFA } from "@/contexts/MFAContext";
import { useEffect } from "react";
import { logger } from "@/lib/logger";

const MFASetupPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { hasEnrolledTOTP, isLoadingMFAStatus } = useMFA();

  // If user already has MFA enrolled, redirect them
  useEffect(() => {
    if (!isLoadingMFAStatus && hasEnrolledTOTP) {
      logger.debug("MFASetupPage: User already has MFA enrolled, redirecting to connect-jotform");
      navigate("/connect-jotform", { replace: true });
    }
  }, [hasEnrolledTOTP, isLoadingMFAStatus, navigate]);

  const handleEnrolled = () => {
    logger.debug("MFASetupPage: MFA enrollment complete, redirecting to connect-jotform");
    navigate("/connect-jotform", { replace: true });
  };

  if (!user) {
    return null; // PrivateRoute should handle this
  }

  if (isLoadingMFAStatus) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-grow container mx-auto px-4 py-12">
        <header className="text-center mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Secure Your Account
          </h1>
          <p className="mt-3 text-lg text-muted-foreground max-w-xl mx-auto">
            Two-factor authentication is required to protect your FAB account access.
            This only takes a minute to set up.
          </p>
        </header>

        <EnrollMFA onEnrolled={handleEnrolled} />

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground max-w-md mx-auto">
            FAB requires two-factor authentication because the permissions necessary
            have full access to your forms and data. This ensures your account stays secure
            even if your password is compromised.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MFASetupPage;
